const getters = {
	getListTransaksiEpayment: (state) => state.listTransaksiEpayment,
	getListTopupEpayment: (state) => state.listTopupEpayment,
	getListPaketEpaymentOwner: (state) => state.listPaketEpaymentOwner,
	getInfoTopupEpayment: (state) => state.infoTopupEpayment,
	getDetailTopupEpayment: (state) => state.detailTopupEpayment,

	// filter
	getPagination: (state) => state.pagination,

	// search
	getSearchTopup: (state) => state.searchTopup,
	getIsSearchTopup: (state) => state.isSearchTopup,

	getScrollPosition: (state) => state.scrollPosition,
}

export default getters